import { faCalendarCheck } from '@fortawesome/free-solid-svg-icons';
import { memo, useMemo } from 'react';

import { Banner } from '@/ui';
import { daysBetween } from '@/utils/dates';

import type { Props } from './types';

const LastAppointmentBanner = ({ lastAppointmentAttended }: Props) => {
  const daysSinceLastAppointment = useMemo(() => {
    if (!lastAppointmentAttended) {
      return 'N/A';
    }

    const { appointment_start_at } = lastAppointmentAttended;
    return `${daysBetween(new Date(appointment_start_at), new Date(), true)} days ago`;
  }, [lastAppointmentAttended]);

  return (
    <Banner
      color="blue"
      detail={lastAppointmentAttended?.appointment_type_name}
      icon={faCalendarCheck}
      label={`Last Appt. Attended ${daysSinceLastAppointment}`}
    />
  );
};
export default memo(LastAppointmentBanner);
